import { DataBean } from "../DataBean";

export class ProjectInfo extends DataBean {



    public async createProjectDataTable(idAccountantConcept: any, idProject: any, fromDate: any, uptoDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_createProjectDataTable_Number_Number_java.util.Date_java.util.Date", [idAccountantConcept, idProject, fromDate, uptoDate]);
    }

}